<template>
    <CodiceFeanorView tool-module="signature" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
